import { RealtySavedScreenContent } from "../../features/realtyList";

// RealtySavedScreen — route landing for /saved.
// Thin composition wrapper. Substrate: canonical .saved-section
// #Csection envelope from modernize.css (see design/saved.html).
// The container + centered title + grid live INSIDE the feature
// widget.

function RealtySavedScreen() {
  return (
    <section className="saved-section" id="Csection" tabIndex="-1">
      <RealtySavedScreenContent />
    </section>
  );
}

export default RealtySavedScreen;
